import { CardComponentProps } from "@~/types/types";
import styles from "./WishList.module.scss";
import { isMultiSkuProduct, isProductSetProduct } from "../../utils/product";
import { useProductCardEvent } from "@~/contexts/ProductCardEventContext/ProductCardEventContext.tsx";
import { productCardEvents } from "@~/contexts/ProductCardEventContext/productCardEvents";

export function WishList({ product }: Pick<CardComponentProps, "product">) {
  const dispatchCardEvent = useProductCardEvent();

  if (isProductSetProduct(product)) {
    return null;
  }

  const isMultiSku = isMultiSkuProduct(product);
  const defaultSkuId = product.variants?.[0]?.aliases?.skuId || null;

  return (
    <div
      data-component="pcl-WishList"
      className={styles["wish-list-icon"]}
      data-product-id={product.aliases.pimProductId}
      data-product-multi-sku={isMultiSku ? "true" : "false"}
      data-product-skuid={defaultSkuId}
      data-wishlist-placeholder
      onClick={() => {
        dispatchCardEvent(productCardEvents.addToWishlist);
      }}
    />
  );
}
